import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0535 = React.lazy(() => import('./symbols/0535_navigation_location_drop_pin_map'));
const Symbol0536 = React.lazy(() => import('./symbols/0536_navigation_location_drop_pin_map'));
const Symbol0537 = React.lazy(() => import('./symbols/0537_navigation_location_drop_pin_map'));
const Symbol0538 = React.lazy(() => import('./symbols/0538_navigation_compass_orientation'));
const Symbol0539 = React.lazy(() => import('./symbols/0539_map_path_navigation_location'));
const Symbol0540 = React.lazy(
  () => import('./symbols/0540_map_path_navigation_location_treasure_hunt')
);
const Symbol0541 = React.lazy(() => import('./symbols/0541_path_way_road_sign'));
const Symbol0542 = React.lazy(() => import('./symbols/0542_path_way_road_sign'));
const Symbol0543 = React.lazy(() => import('./symbols/0543_world_earth_worldwide_location_travel'));
const Symbol0544 = React.lazy(
  () => import('./symbols/0544_world_earth_worldwide_international_language')
);
const Symbol0545 = React.lazy(() => import('./symbols/0545_map_travel_distance_directions'));
const Symbol0546 = React.lazy(() => import('./symbols/0546_map_travel_destination_location_world'));
const Symbol0547 = React.lazy(() => import('./symbols/0547_path_travel_road'));

export interface IProps {}

const Maps: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0535_navigation_location_drop_pin_map" symbol={<Symbol0535 />} />
      <LazySymbol id="0536_navigation_location_drop_pin_map" symbol={<Symbol0536 />} />
      <LazySymbol id="0537_navigation_location_drop_pin_map" symbol={<Symbol0537 />} />
      <LazySymbol id="0538_navigation_compass_orientation" symbol={<Symbol0538 />} />
      <LazySymbol id="0539_map_path_navigation_location" symbol={<Symbol0539 />} />
      <LazySymbol id="0540_map_path_navigation_location_treasure_hunt" symbol={<Symbol0540 />} />
      <LazySymbol id="0541_path_way_road_sign" symbol={<Symbol0541 />} />
      <LazySymbol id="0542_path_way_road_sign" symbol={<Symbol0542 />} />
      <LazySymbol id="0543_world_earth_worldwide_location_travel" symbol={<Symbol0543 />} />
      <LazySymbol id="0544_world_earth_worldwide_international_language" symbol={<Symbol0544 />} />
      <LazySymbol id="0545_map_travel_distance_directions" symbol={<Symbol0545 />} />
      <LazySymbol id="0546_map_travel_destination_location_world" symbol={<Symbol0546 />} />
      <LazySymbol id="0547_path_travel_road" symbol={<Symbol0547 />} />
    </>
  );
});

Maps.displayName = 'Maps';

export default Maps;
